import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AdminProducts from "./AdminProducts";
import AdminOrders from "./AdminOrders";
import AdminShipping from "./AdminShipping";
import AdminCategories from "./AdminCategories";
import AdminSettings from "./AdminSettings";

const tabCls = "rounded-full px-4 font-bold data-[state=active]:bg-[#0b0b0f] data-[state=active]:text-white";

export default function AdminPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 pt-6 sm:px-6">
      <h1 className="text-3xl font-extrabold tracking-tight">Admin negozio</h1>
      <Tabs defaultValue="products" className="mt-5">
        <TabsList className="h-auto flex-wrap rounded-full border-2 border-[#0b0b0f] bg-white p-1">
          <TabsTrigger data-testid="admin-tab-products" value="products" className={tabCls}>Articoli</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-orders" value="orders" className={tabCls}>Ordini</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-shipping" value="shipping" className={tabCls}>Spedizioni</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-categories" value="categories" className={tabCls}>Categorie</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-settings" value="settings" className={tabCls}>Vetrina</TabsTrigger>
        </TabsList>
        <TabsContent value="products" className="mt-5"><AdminProducts /></TabsContent>
        <TabsContent value="orders" className="mt-5"><AdminOrders /></TabsContent>
        <TabsContent value="shipping" className="mt-5"><AdminShipping /></TabsContent>
        <TabsContent value="categories" className="mt-5"><AdminCategories /></TabsContent>
        <TabsContent value="settings" className="mt-5"><AdminSettings /></TabsContent>
      </Tabs>
    </div>
  );
}
